import { Card, CardContent, Grid, Stack, Typography } from '@mui/material'
import { FunctionComponent } from 'react';
import { IHeadCell } from '../../../shared/interfaces/table-display.model';

export const TableDisplayEmissionsMobile: FunctionComponent<{
  rows: any,
  headCells: IHeadCell[],
  haveCheckboxSelect?: boolean,
  selectByIcon?: boolean,
  selectByCheckboxOnly?: boolean,
  number?: number
  handleSelected?: (selectedRowId: string[]) => void;
  selected: string[],
  setSelected: React.Dispatch<React.SetStateAction<any>>
}> = (
  {
    rows,
    headCells,
    handleSelected,
  }) => {

    const generateCardContent = (row: any, headCells: IHeadCell[]) => {
      return (
        <Stack spacing={1}>
          <Stack direction='row' justifyContent='space-between'>
            <Stack direction='column' >
              <Typography>
                Start Date:
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                {row.startDate}
              </Typography>
            </Stack >
            {row.endDate && <Stack direction='column' >
              <Typography>
                End Date:
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                {row.endDate}
              </Typography>
            </Stack>}
          </Stack>
          {row.group && <Stack direction='row' flexWrap='wrap'>
            <Typography variant='body1'>
              {row.group}
            </Typography>
          </Stack>}
          {row.category && <Stack direction='row' flexWrap='wrap'>
            <Typography variant='body1'>
              {row.category}
            </Typography>
          </Stack>}
          {row.additional && <Stack direction='row' flexWrap='wrap'>
            <Typography variant='body1'>
              {row.additional}
            </Typography>
          </Stack>}
          <Stack direction='row' justifyContent='space-between' flexWrap='wrap'>
            <Stack direction='row' spacing={0.5} alignItems='center'>
              <Typography variant='body1'>
                {row.measurement}
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                {row.units}
              </Typography>
            </Stack>
            <Stack direction='row' spacing={0.5} alignItems='center'>
              <Typography >
                {row.emissionAmount}
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                kg CO2e
              </Typography>
            </Stack>
          </Stack>
        </Stack>

      );
    };

    return (
      <Grid container spacing={2}>
        {rows.map((row: any) => (
          <Grid item xs={12} md={6} lg={4} key={row.id}>
            <Card onClick={() => handleSelected && handleSelected([row.id])} sx={{ cursor: 'pointer', pt: 0.5, pl: 1, pr: 1, pb: 0.5 }} variant='outlined'>
              <CardContent>
                {generateCardContent(row, headCells)}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    )
  }